import { render } from "./ImageElementProduction.vue.js?vue&type=template&id=ca156b0a&scoped=true!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ImageElementProduction.vue?vue&type=template&id=ca156b0a&scoped=true"
import script from "./ImageElementProduction.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ImageElementProduction.vue?vue&type=script&lang=js"
export * from "./ImageElementProduction.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ImageElementProduction.vue?vue&type=script&lang=js"

import "./ImageElementProduction.vue.scss?vue&type=style&index=0&id=ca156b0a&lang=scss&scoped=true!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ImageElementProduction.vue?vue&type=style&index=0&id=ca156b0a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca156b0a"],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/image-element/ImageElementProduction.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ca156b0a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ca156b0a', __exports__)) {
    api.reload('ca156b0a', __exports__)
  }
  
  module.hot.accept("./ImageElementProduction.vue.js?vue&type=template&id=ca156b0a&scoped=true!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ImageElementProduction.vue?vue&type=template&id=ca156b0a&scoped=true", () => {
    api.rerender('ca156b0a', render)
  })

}


export default __exports__